import React from 'react';
import { useTranslation } from 'react-i18next';
import { TranslationKey } from '../../i18n/translationKeys';
import { OnboardingHeader } from './OnboardingHeader';

export const ScreenWelcome: React.FC = () => {
    const { t } = useTranslation();

    return (
        <div data-testid="onboarding-screen-welcome" className="flex flex-col items-center text-center gap-l max-w-md">
            <OnboardingHeader title={t(TranslationKey.Onboarding.Welcome.Title)} />
            <p className="text-body-emphasized text-content">{t(TranslationKey.Onboarding.Welcome.Hook)}</p>
            <p className="text-body text-content-secondary">{t(TranslationKey.Onboarding.Welcome.BodyOne)}</p>
            <p className="text-body text-content-secondary">{t(TranslationKey.Onboarding.Welcome.BodyTwo)}</p>
            <p className="text-body text-content-secondary">{t(TranslationKey.Onboarding.Welcome.Note)}</p>
        </div>
    );
};
